module.exports = __webpack_public_path__ + "static/img/banner-1-right.61e7de0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/banner-1-right.png
// module id = 5srM
// module chunks = 1